import React from "react";
import VehicleNotAttachedScreen from "../components/VehicleNotAttachedScreen";

function Notfound() {
  return <VehicleNotAttachedScreen />;
}

export default Notfound;
